<script>
import appConfig from "../../../app.config";
import axios from 'axios';
import DataTable from 'datatables.net-vue3';
import moment from 'moment';
import { usePermissions } from '@/composables/usePermissions';

export default {
    page: {
        title: "Orders",
        meta: [{ name: "description", content: appConfig.description }],
    },
    props: {
        customerid :{
            type : Number,
        }
    },
    data(){
        return {
            customer_contract_info:[],
            loadingDetail:false,
            loadingRoles:true,
            ButtonSeen:true,
        };  
    },
  setup() {
        const {
            canReadContracts,
            canCreateContracts,
            canUpdateContracts
        } = usePermissions()
        return {
            canReadContracts,
            canCreateContracts,
            canUpdateContracts,
        };
    },
    methods: {
        format_date(value){
            if (value) {
                return moment(String(value)).format('DD-MM-YYYY')
            }
        },

        get_customer_order_by_id(){
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'contract/customer_contract/'+this.customerid)
        .then(response => {
            if (response) {
                this.loadingRoles=false;
                this.customer_contract_info = response.data;
                console.log(this.customer_contract_info);
            } 
            else {
                this.messageBag = ['No record.'];
            }
        })
        .catch(error => {
            this.messageBag = [error.error];
        });
    }, 
    },

    components: {
        DataTable,
    },

    mounted() {
        this.get_customer_order_by_id();     
    },
};
require("@/assets/css/datatable.css");
</script>

<template>
  <div class="card card-height-100" v-if="canReadContracts">
    <div class="card-body p-0">
      <div>
        <div v-if='loadingRoles'>
              <div class="spinner-border text-success" role="status">
                  <span class="sr-only">Loading...</span>
              </div>
          </div>
          <div v-else>
            <div class="table-responsive">
                <DataTable :options="{lengthChange: false}" class="table table-striped table-nowrap mb-0"> 
                    <thead class="table-secondary">
                         <tr>
                            <th>#.</th>
                            <th scope="col">Contract Number</th>           
                            <th scope="col">Customer Name</th>           
                            <th scope="col">SKU</th>           
                            <th scope="col">IMEI</th>
                            <th scope="col">Enrolled MDM</th>           
                            <th scope="col">Order Number</th>                                                      
                            <th scope="col">Program</th>
                            <th scope="col">Device Name</th>
                            <th scope="col">Price</th>
                            <th scope="col">Contract Signed Date</th>
                        </tr>
                    </thead>
                    <tbody>                                
                        <tr v-for="(item, index) in customer_contract_info" :key="index" class="content">
                            <td>{{ index+1 }}</td>
                            <td><router-link :to="'/contracts/customer-contract-details/'+item.contract_id" class="fw-medium link-secondary">{{ item.contract_number }}</router-link></td>                               
                            <!--td>{{ item.orderId }}</td-->
                            <td>{{ item.name_as_per_nric }}</td>
                            <td>{{ item.sku }}</td>
                            <td>{{ item.imei }}</td>
                            <td class="text-center">
                                <span v-if="item.is_device_mdm == null" class="badge badge-soft-secondary fs-11">
                                    <i class="ri-question-line align-middle me-1"></i> N/A
                                </span>
                                <span v-else-if="item.is_device_mdm == 1" class="badge badge-soft-success fs-11">
                                    <i class="ri-checkbox-circle-line align-middle me-1"></i> Yes
                                </span>
                                <span v-else class="badge badge-soft-danger fs-11">
                                    <i class="ri-close-circle-line align-middle me-1"></i> No
                                </span>
                            </td>
                            <td>{{ item.orderId }}</td>
                            <td>{{ item.program_name }}</td>                                          
                            <td>{{ item.product_name }}</td>                                          
                            <td>RM {{ item.price }}</td>                                                                                  
                            <td>{{ this.format_date(item.commencement_date) }}</td>                                                                                  
                        </tr>
                    </tbody>
                </DataTable>
            </div>
        </div>
      </div>
    </div>
  </div>

    <div v-else class="text-center text-muted p-4">
            You do not have permission to view Contracts.
     </div>

</template>
